


















































import ModalMixin from '@/components/modal/mixin.vue';
import E2EMixin from '@/components/mixins/E2EMixin';
import mixins from 'vue-typed-mixins';

export default mixins(E2EMixin, ModalMixin).extend({
  methods: {
    deleteAccount(e) {
      e.preventDefault();
      if (confirm('本当にアカウントを削除してもよろしいですか？')) {
        this.$emit('submit');
      }
    },
  },
});
